import * as beneficiaryCommentSchema from 'schemas/forms/BeneficiaryComment'
import Heading from 'components/Heading'
import Table from 'components/Table'
import Card from 'components/Card'
import Modal from 'components/Modal'
import { validateAll } from 'utils/validators'
import React, { PropTypes, Component } from 'react'
import SubmitButton from 'components/SubmitButton'
import TextInput from 'components/Form/components/TextInput'
import Alert from 'components/Alert'

import {
  formUpdate,
  formInit,
  formSubmit,
  formReset,
} from 'actions/forms'

const styles = Object.assign(
  {},
  require('./BeneficiaryDisplayForm.scss'),
  { columns: require('./columns.scss') },
)

class BeneficiaryCommentForm extends Component {
  static propTypes = {
    beneficiaries: PropTypes.object,
    completeText: PropTypes.string,
    confirmation: PropTypes.bool,
    ctaText: PropTypes.string,
    data: PropTypes.object,
    description: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    handleFormSubmit: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    hasFetched: PropTypes.bool,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    label: PropTypes.string,
    modals: PropTypes.object.isRequired,
    show: PropTypes.bool,
    submittingText: PropTypes.string,
    title: PropTypes.string,
  }

  static defaultProps = {
    data: {},
    ctaText: 'Submit',
    completeText: 'Submitted',
    submittingText: 'Submitting',
    show: false,
    confirmation: false,
    beneficiaries: null,
    description: '',
    hasFetched: false,
    id: '',
    title: '',
    label: '',
    handleFormSubmit: null,
  }

  componentWillMount() {
    const { formFields } = beneficiaryCommentSchema

    const formData = {
      formFields,
      data: this.props.data || null,
    }

    this.props.dispatch(formInit(this.props.id, formData))
  }

  componentWillReceiveProps(nextProps) {
    const modalCreated = this.props.modals.beneficiaryComment
    const modalChanged = modalCreated && nextProps.modals.beneficiaryComment.show !== this.props.modals.beneficiaryComment.show
    const modalNotVisible = modalCreated && !nextProps.modals.beneficiaryComment.show
    const modalVisible = modalCreated && nextProps.modals.beneficiaryComment.show

    if (modalChanged && modalNotVisible) {
      this.props.dispatch(formReset(this.props.id))
    }
    if (modalChanged && modalVisible) {
      // preload data from BED if needed
      this._handleChange('previousComments', this.props.beneficiaries.comments)
    }
  }

  _schema = () => {
    const obj = {}
    beneficiaryCommentSchema.formFields.forEach((field) => {
      obj[field.name] = field
    })
    return obj
  }

  _hide = () => {
    // this.props.dispatch(displayForm(false))
    this.props.hide(this.props.id)
    this.props.dispatch(formReset(this.props.id))
  }

  _handleSubmit = (e) => {
    e.preventDefault()
    const values = this.props.forms[this.props.id]
    const data = {}
    Object.keys(values).forEach((key) => {
      if (key.indexOf('_') < 0) {
        data[key] = values[key].value
      }
    })

    const errors = validateAll(beneficiaryCommentSchema.requiredFields, this.props.forms[this.props.id])

    // Check if form has errors
    if (errors.length > 0) {
      // If form has errors handle them
      errors.forEach((errObj) => {
        this._handleError(errObj, errObj.name)
      })
    } else {
      // If form has no errors, pass the serialized form field for submit and set the form to submit.
      this.props.dispatch(formSubmit(this.props.id))
      this.props.handleSubmit(data)
    }
  }

  // Takes an error object for a field and updates the state accordingly
  _handleError(errorObj, stateKey) {
    // Set new state value for field and update state
    const stateValue = {
      data: {
        focus: false,
        error: (errorObj.valid) ? '' : errorObj.error,
        valid: errorObj.valid,
      },
      field: stateKey,
    }
    this._handleState(stateValue)
  }

  _handleState = (stateValue) => {
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleAutoComplete = (name, value) => {
    this._handleChange(name, value)
  }

  // Handle Changes on form elements
  _handleChange = (name, value) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }

    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  canSubmit = () => {
    const form = this.props.forms[this.props.id]
    return form.comments.value

    // if (this.state.showSignedUpload) {
    //   return !!form.groupOrEntity.value
    // }
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      title,
      dispatch,
      // frequencies,
      // groupsAndEntities,
      modals,
      // serviceTypes,
      description,
      label,
    } = this.props
    const schema = this._schema()
    const form = this.props.forms[this.props.id]
    const disable = (form && form._isPosting)
    const forceClose = (form && form._hasCompleted)
    // const formHasFetched = this.props.hasFetched
    const previousComments = (this.props.beneficiaries.comments
      ? this.props.beneficiaries.comments.split('|')
      : this.props.beneficiaries.comments)

    return (
      <Modal
        className={styles.bg}
        disable={disable}
        dispatch={dispatch}
        forceClose={forceClose}
        id="beneficiaryComment"
        modals={modals}
        onClose={this._hide}
      >
        <div className={styles.base}>
          <Heading className={styles.title} size="large">
            {title}
          </Heading>
          <p className={styles.content}>{description}</p>
          <Alert type="info">
          Please add name and date when submitting notes.
          </Alert>
          {form &&
          <form
            className={styles.form}
            id={this.props.id}
            noValidate="novalidate"
            onSubmit={this._handleSubmit}
          >
            <div className={styles.sectionHeader}>
              {label}
            </div>
            <fieldset>
              <ul>
                <li>
                  <TextInput
                    {...schema.comments}
                    error={form.comments.error}
                    focus={form.comments.focus}
                    handleChange={this._handleChange}
                    multiline
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.comments.value}
                    valid={form.comments.valid}
                  />
                </li>
              </ul>
            </fieldset>
            <br /><br />
            <div className={styles.footer}>
              <SubmitButton
                complete={this.props.forms[this.props.id]._isComplete}
                completeText={completeText}
                disabled={!this.canSubmit()} // Add validation rules
                isLarge
                submitting={this.props.forms[this.props.id]._isPosting}
                submittingText={submittingText}
              >
                {ctaText}
              </SubmitButton>
            </div>
          </form>
          }
          { previousComments && <section>
            <Heading>Previous notes</Heading>
            <Card noPadding>
              <Table className={styles.baseComment}>
                {previousComments.map(benef => (<tr className={styles.base}>
                  <td className={styles.columns.comment}>{benef}</td>
                </tr>))
                }
              </Table>
            </Card>
          </section>
          }
        </div>
      </Modal>
    )
  }
}

/* const mapStateToProps = (state) => ({
  beneficiaries: state.beneficiaries,
}) */

export default BeneficiaryCommentForm
//



// WEBPACK FOOTER //
// ./src/views/Beneficiaries/BeneficiaryCommentForm.js